import React, { useState } from "react";
import "./Testimonials.css";
import Heading_title from "../../common-components/common-title/heading-title/Heading_title";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUser,
  faQuoteLeft,
  faAngleLeft,
  faAngleRight,
} from "@fortawesome/free-solid-svg-icons";

library.add(faUser, faQuoteLeft, faAngleLeft, faAngleRight);

const Testimonials = () => {
  const data = [
    {
      review:
        "“It is encouraging to see initiatives like Ashwa Sports that inspire young talent and support grassroots sports development. Such platforms play an important role in building a healthier and more active society.”",
      img: "/assets/images/testimonials/img1.png",
      name: "Kiran Dagde Patil",
    },
    {
      review:
        "“Ashwa Sports is a fantastic initiative that encourages people to embrace fitness and sports as a lifestyle. Their approach is modern, motivating, and impactful.”",
      img: "/assets/images/testimonials/img1.png",
      name: "Akash Thosar",
    },
    {
      review:
        "“I’ve been using Ashwa Sports for a few months now, and I can honestly say it’s helped me stay consistent with my fitness routine. The quality and experience are really good.”",
      img: "/assets/images/testimonials/img1.png",
      name: "Nilesh Nehte",
    },
    {
      review:
        "“Ashwa Sports has really helped me stay consistent with my fitness routine. It’s simple, reliable, and fits perfectly into my daily schedule.”",
      img: "/assets/images/testimonials/img1.png",
      name: "Miss Shital",
    },
    {
      review:
        "“I love how Ashwa Sports makes fitness fun and easy to follow. It’s motivating, reliable, and really helps me stay on track every day.”",
      img: "/assets/images/testimonials/img1.png",
      name: "Aarti Bendre",
    },
    {
      review:
        "“Ashwa Sports stands out as a platform that promotes discipline, teamwork, and fitness. I appreciate their dedication and see great value in what they are building for the community.”",
      img: "/assets/images/testimonials/img1.png",
      name: "Pankaj Jagpuriya",
    },
  ];

  const [swiperInstance, setSwiperInstance] = useState(null);

  const handleMainSliderClick = (direction) => {
    console.log("swiperInstance", swiperInstance, direction);

    if (swiperInstance) {
      if (direction === "prev") {
        swiperInstance.slidePrev();
      } else if (direction === "next") {
        swiperInstance.slideNext();
      }
    }
  };

  return (
    <section className="Testimonials">
      <div className="container">
        <div className="main_content_div">
          <Heading_title
            title={"Testimonials"}
            subtitle={
              "See what our participants and partners say about their journey with us."
            }
          />

          <div className="swiper_div">
            <Swiper
              onSwiper={setSwiperInstance}
              slidesPerView={1}
              spaceBetween={10}
              modules={[Navigation]}
              breakpoints={{
                "0": {
                  slidesPerView: 1.2,
                  spaceBetween: 0,
                },
                "350": {
                  slidesPerView: 1.3,
                  spaceBetween: 0,
                },
                "450": {
                  slidesPerView: 1.6,
                  spaceBetween: 0,
                },
                "575": {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                "768": {
                  slidesPerView: 2.5,
                  spaceBetween: 10,
                },
                "992": {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                "1200": {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                "1400": {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
              }}
              centeredSlides={true}
              loop={true}
              className="mySwiper"
            >
              {data.map((item, index) => (
                <SwiperSlide>
                  <div className="white_review_card">
                    <div className="quote_img_div">
                      <img
                        src="/assets/images/testimonials/quote.png"
                        className="quote_img"
                      />
                    </div>

                    <p className="review_text">{item?.review}</p>

                    {/* <div className="img_holder">
                      <img
                        src={process.env.PUBLIC_URL + item?.img}
                        className="profile_img"
                      />
                    </div> */}
                    <div className="img_holder">
                      <FontAwesomeIcon
                        icon={["fas", "user"]}
                        className="profile_icon"
                      />
                    </div>
                    <p className="name_text">{item?.name}</p>
                    <p className="desgn_text">{item?.desgn}</p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* <div className="silder_btn"> */}
            <div
              className="back_btn_holder"
              onClick={() => handleMainSliderClick("prev")}
            >
              <div className="back_btn">
                <p>
                  {" "}
                  <FontAwesomeIcon icon={faAngleLeft} className="icon" />
                </p>
              </div>
            </div>
            <div
              className="back_btn_holder next"
              onClick={() => handleMainSliderClick("next")}
            >
              <div className="back_btn">
                <p>
                  {" "}
                  <FontAwesomeIcon icon={faAngleRight} className="icon" />
                </p>
              </div>
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
